import * as React from 'react';
import { getProspectUserAuditDetails } from '../../../../api/ProspectUser';
import { useFetch } from '../../../../hooks/useFetch';
import * as moment from 'moment';

export const ProspectAuditInfo = ({ publicKey }: { publicKey: string }) => {
    const { data: prospectAuditDetails } = useFetch(
        () => getProspectUserAuditDetails(publicKey),
        [],
        null
    );

    return (
        <>
            {prospectAuditDetails && prospectAuditDetails.lastUpdatedDateTime
                ? `Last updated by ${prospectAuditDetails.lastUpdatedByUser} at
                                ${moment(prospectAuditDetails.lastUpdatedDateTime).format(
                                    'MM/DD/YYYY LT'
                                )}`
                : ''}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/prospectAuditInfo.tsx